import { Component, OnInit, inject } from "@angular/core";
import { UsersService } from "@shared/services/users/users.service";
import { WcmService } from "@shared/services/wcm/wcm.service";

@Component({
	selector: "app-server-maintenance",
	templateUrl: "./server-maintenance.component.html",
	styleUrl: "./server-maintenance.component.scss",
	standalone: false
})
export class ServerMaintenanceComponent implements OnInit {
	wcmService = inject(WcmService);
	userService = inject(UsersService);

	ngOnInit() {
		this.userService.resetProfile();
	}
}